<template>
  <div class="status-register-result-statistics">
    <slot :toggle-visible="toggleVisible"></slot>
    <DataGridDialog :visible.sync="visible"
                    width="900px"
                    title="学生注册情况统计"
                    custom-class="status-register-result-statistics-dialog"
                    @open="loadStatisticsInfo">
      <div class="statistics-wrap"
           v-loading="loading"
           element-loading-text="数据加载中，请稍等...">
        <template v-if="statisticsInfo">
          <div class="graph">
            <div class="graph-wrap">
              <EChartContainer ref="chart"></EChartContainer>
            </div>
          </div>
          <div class="table">
            <div class="table-wrap">
              <DataGrid size="mini"
                        height="auto"
                        resizable
                        row-id="id"
                        :tree-config="{reserve: true, expandAll: true}"
                        :data="getRecords">
                <DataGridColumn title="教学点/班级"
                                field="name"
                                tree-node></DataGridColumn>
                <DataGridColumn title="学生数"
                                field="value"
                                width="80"
                                align="center"></DataGridColumn>
                <DataGridColumn title="未注册"
                                field="unregisterCount"
                                width="80"
                                align="center"></DataGridColumn>
                <DataGridColumn title="已注册"
                                field="registeredCount"
                                width="80"
                                align="center"></DataGridColumn>
              </DataGrid>
            </div>
          </div>
        </template>
        <template v-else>
          <Hint v-if="!loading"
                type="error">
            <span>学生注册数据加载失败</span>
            <el-button type="text"
                       @click="loadStatisticsInfo">重新加载</el-button>
          </Hint>
        </template>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridDialog from '../../../../../../../elements/grid/DataGridDialog'
import EChartContainer from '../../../../../../../elements/EChartContainer'
import DataGrid from '../../../../../../../elements/DataGrid'
import DataGridColumn from '../../../../../../../elements/DataGridColumn'
import Hint from '../../../../../../../elements/Hint'
export default {
  name: 'StatusRegisterResultStatistics',
  components: {
    DataGridDialog,
    EChartContainer,
    DataGrid,
    DataGridColumn,
    Hint
  },
  data () {
    return {
      visible: false,
      loading: false,
      statisticsInfo: null
    }
  },
  computed: {
    getSeries () {
      let statisticsInfo = this.statisticsInfo
      if (statisticsInfo) {
        let sites = statisticsInfo.sites || []
        return sites.map(site => {
          let children = (site.children || []).map(clazz => {
            return {
              type: 'clazz',
              id: clazz.id,
              name: clazz.name,
              value: clazz.studentCount || 0,
              unregisterCount: clazz.unregisterCount || 0,
              registeredCount: clazz.registeredCount || 0,
              children: [{
                name: '未注册',
                value: clazz.unregisterCount || 0,
                itemStyle: {
                  color: '#DD4C51'
                },
                label: {
                  rotate: 'radial'
                }
              }, {
                name: '已注册',
                value: clazz.registeredCount || 0,
                itemStyle: {
                  color: '#1A8633'
                },
                label: {
                  rotate: 'radial'
                }
              }]
            }
          })
          return {
            type: 'site',
            id: site.id,
            name: site.name,
            value: site.studentCount || 0,
            unregisterCount: site.unregisterCount || 0,
            registeredCount: site.registeredCount || 0,
            children: children
          }
        })
      }
    },
    getRecords () {
      let statisticsInfo = this.statisticsInfo
      if (statisticsInfo) {
        let sites = statisticsInfo.sites || []
        return sites.map(site => {
          let children = (site.children || []).map(clazz => {
            return {
              type: 'clazz',
              id: clazz.id,
              name: clazz.name,
              value: clazz.studentCount || 0,
              unregisterCount: clazz.unregisterCount || 0,
              registeredCount: clazz.registeredCount || 0
            }
          })
          return {
            type: 'site',
            id: site.id,
            name: site.name,
            value: site.studentCount || 0,
            unregisterCount: site.unregisterCount || 0,
            registeredCount: site.registeredCount || 0,
            children: children
          }
        })
      }
    }
  },
  methods: {
    toggleVisible () {
      this.visible = !this.visible
    },
    loadStatisticsInfo () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/status/register/result/statisticsInfo',
        method: 'post'
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.statisticsInfo = response.data['statisticsInfo'] || {}
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    initChart () {
      let getSeries = this.getSeries
      if (getSeries) {
        this.$nextTick(() => {
          const chart = this.$refs.chart
          if (chart) {
            chart.setOption({
              tooltip: {
                trigger: 'item',
                formatter: param => {
                  if (param.name) {
                    switch (param.data.type) {
                      case 'site':
                      case 'clazz': {
                        const studentCount = param.value
                        const unregisterCount = param.data.unregisterCount || 0
                        const registeredCount = param.data.registeredCount || 0
                        const unregisterRatio = studentCount ? (unregisterCount * 100 / studentCount).toFixed(2) : 0
                        const registeredRatio = studentCount ? (registeredCount * 100 / studentCount).toFixed(2) : 0
                        return `<div>${param.marker}${param.name}</div>
                          <div>学生数：<span style="color:${param.color}">${studentCount}</span></div>
                          <div>未注册：<span style="color: #DD4C51">${unregisterCount}</span>（${unregisterRatio}%）</div>
                          <div>已注册：<span style="color: #1A8633">${registeredCount}</span>（${registeredRatio}%）</div>`
                      }
                      default: {
                        const treePath = (param.treePathInfo || [])
                          .filter(path => !!path.name)
                          .map(path => path.name)
                          .join(' / ')
                        return `<div>${param.marker}${treePath || param.name}：<span style="color:${param.color}">${param.value}</span></div>`
                      }
                    }
                  }
                },
                appendToBody: true
              },
              series: {
                type: 'sunburst',
                emphasis: {
                  focus: 'ancestor'
                },
                data: getSeries,
                radius: [0, '75%'],
                label: {
                  rotate: 'tangential',
                  textShadowColor: '#fff'
                }
              }
            })
          }
        })
      }
    }
  },
  watch: {
    statisticsInfo () {
      this.initChart()
    }
  }
}
</script>

<style lang="scss">
  .status-register-result-statistics {
    display: inline-block;
  }
  .status-register-result-statistics-dialog {
    .statistics-wrap {
      height: 420px;
      display: flex;
      align-items: stretch;
      & > .graph {
        flex: none;
        position: relative;
        width: 420px;
        & > .graph-wrap {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
          .e-chart-container {
            height: 100%;
          }
        }
      }
      & > .table {
        flex: auto;
        position: relative;
        & > .table-wrap {
          position: absolute;
          left: 10px;
          top: 10px;
          right: 10px;
          bottom: 10px;
        }
      }
    }
  }
</style>
